var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _setup.organizationId
      ? _c(
          "div",
          { staticClass: "container" },
          [
            _setup.logoUrl
              ? _c("img", {
                  staticStyle: { "max-width": "200px" },
                  attrs: { src: _setup.logoUrl },
                })
              : _vm._e(),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c(
              _setup.FileUploader,
              {
                attrs: {
                  ttl: null,
                  skipConfirmation: false,
                  hideProgress: true,
                  accept: "image/png,image/gif,image/jpeg,image/svg+xml",
                },
                on: {
                  selected: function ($event) {
                    _setup.logoFile = $event
                  },
                  uploaded: _setup.handleLogoUploaded,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "file",
                      fn: function () {
                        return [_vm._v("\n                 \n            ")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2274607451
                ),
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                  },
                  [_vm._v("Change logo")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _setup.logoBlobId
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _setup.handleRemoveLogo },
                  },
                  [_vm._v("Remove logo")]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Manage company branding")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }